import { faSquarePen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { ROUTES } from 'Utils/constants'

export function useColumnSearchInvoice() {
  const history = useHistory()
  return useMemo(
    () => [
      {
        accessor: 'CustomerName',
        Header: 'Nombre del cliente',
        width: '200px',
      },
      {
        accessor: 'IntegrationDocumentId',
        Header: 'ID Factura',
        width: '200px',
      },
      {
        accessor: 'PurchaseOrderId',
        Header: 'ID de Orden de compra',
        width: '200px',
        Cell: ({ row }) => {
          const purchaseID = row.original.PurchaseOrderId

          return purchaseID || 'Desconocido'
        },
      },
      {
        accessor: 'BranchOfficeName',
        Header: 'Sucursal',
        width: '200px',
      },
      {
        accessor: 'TotalAmount',
        Header: 'Monto total',
        width: '200px',
        Cell: ({ row }) => {
          const amount = Number.parseFloat(row.original.TotalAmount)
          const formatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(amount)

          return formatted
        },
      },
      {
        accessor: 'IssueDate',
        Header: 'Fecha',
        width: '200px',
        Cell: ({ row }) => {
          const date = row.original.IssueDate

          return moment(date).format('DD/MM/YYYY')
        },
      },
      {
        accessor: 'SalespersonName',
        Header: 'Vendedor',
        width: '200px',
      },
      {
        accessor: 'actions',
        Header: 'Acciones',
        width: '80px',
        Cell: ({ row }) => (
          <span>
            <FontAwesomeIcon
              icon={faSquarePen}
              style={{ color: '#3FC5DF', fontSize: '2rem', cursor: 'pointer' }}
              onClick={() =>
                history.push(
                  `${ROUTES.invoiceDetail}${row.original?.DocumentNumber}`
                )
              }
            />
          </span>
        ),
      },
    ],
    []
  )
}
